/**
 * HOUNDINGTON OFFICIAL SHOPIFY THEME JS
 * Complete Shopify AJAX Cart API, Dynamic Variant Selection & Localization
 */

// ==========================================================================
// 1. SHOPIFY AJAX CART DRAWER
// ==========================================================================
function toggleCartDrawer(open) {
  const overlay = document.getElementById('cartOverlay');
  const sidebar = document.getElementById('cartSidebar');
  if (!overlay || !sidebar) return;

  if (open) {
    refreshCartDrawer();
    overlay.classList.add('active');
    sidebar.classList.add('active');
    document.body.style.overflow = 'hidden';
  } else {
    overlay.classList.remove('active');
    sidebar.classList.remove('active');
    document.body.style.overflow = '';
  }
}

function refreshCartDrawer() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      renderCartUI(cart);
    })
    .catch(err => console.error('Error fetching cart:', err));
}

function renderCartUI(cart) {
  if (cart && cart.currency) {
    if (!window.HOUNDINGTON) window.HOUNDINGTON = {};
    if (!window.HOUNDINGTON.currency) window.HOUNDINGTON.currency = {};
    window.HOUNDINGTON.currency.code = cart.currency;
  }

  const countEl = document.getElementById('mwCartCounter');
  const drawerCountText = document.getElementById('drawerCountText');
  const listEl = document.getElementById('drawerItemList');
  const subtotalEl = document.getElementById('drawerSubtotal');
  const footerEl = document.getElementById('drawerFooter');

  if (countEl) countEl.textContent = cart.item_count;
  if (drawerCountText) drawerCountText.textContent = cart.item_count;

  if (!listEl) return;

  if (cart.item_count === 0) {
    listEl.innerHTML = `
      <div class="drawer-empty-view">
        <div class="drawer-empty-headline">YOUR SHOPPING BAG IS CURRENTLY EMPTY</div>
        <p style="font-size:12px; line-height:1.6; color:#777;">Explore our Haute Couture collection to select handcrafted creations for your companion.</p>
      </div>
    `;
    if (footerEl) footerEl.style.display = 'none';
    return;
  }

  if (footerEl) footerEl.style.display = 'block';

  listEl.innerHTML = cart.items.map(item => {
    const itemImg = item.image ? item.image : '';
    const itemPrice = formatMoney(item.final_line_price);
    return `
      <div class="drawer-item-tile" data-line-key="${item.key}">
        ${itemImg ? `<img src="${itemImg}" alt="${escapeHtml(item.product_title)}" class="drawer-item-thumb">` : ''}
        <div class="drawer-item-info">
          <div class="drawer-item-name">${escapeHtml(item.product_title)}</div>
          ${item.variant_title ? `<div class="drawer-item-meta">${escapeHtml(item.variant_title)}</div>` : ''}
          <div class="drawer-item-footer">
            <span class="drawer-price-tag">${itemPrice}</span>
            <div class="drawer-qty-stepper">
              <button type="button" onclick="changeCartLineQty('${item.key}', ${item.quantity - 1})">−</button>
              <span>${item.quantity}</span>
              <button type="button" onclick="changeCartLineQty('${item.key}', ${item.quantity + 1})">+</button>
            </div>
          </div>
        </div>
      </div>
    `;
  }).join('');

  if (subtotalEl) {
    subtotalEl.textContent = formatMoney(cart.total_price);
  }

  const shippingNotice = document.getElementById('drawerShippingNotice');
  if (shippingNotice) {
    shippingNotice.textContent = '✨ FREE WORLDWIDE TRACKED SHIPPING ON ALL ORDERS';
  }

  // Update dynamic drawer coupon callout based on quantity
  const couponCallout = document.getElementById('drawerCouponCallout');
  if (couponCallout) {
    if (isCouponCampaignActive()) {
      couponCallout.style.display = 'flex';
      const totalQty = cart.item_count || 0;
      const textEl = couponCallout.querySelector('.drawer-coupon-text');
      if (textEl) {
        if (totalQty >= 2) {
          textEl.innerHTML = '🎉 2+ items in bag! Apply code at checkout: <strong>CCETKFR0KEF1</strong> (10% OFF)';
        } else {
          textEl.innerHTML = 'Add 1 more item for <strong>10% OFF</strong>! Code: <strong>CCETKFR0KEF1</strong>';
        }
      }
    } else {
      couponCallout.style.display = 'none';
    }
  }
}

function changeCartLineQty(lineKey, newQty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: lineKey, quantity: newQty })
  })
    .then(res => res.json())
    .then(cart => renderCartUI(cart))
    .catch(err => console.error('Error changing qty:', err));
}

function addProductToCart(variantId, quantity = 1) {
  if (!variantId) {
    const inputEl = document.getElementById('selectedVariantId');
    if (inputEl && inputEl.value) {
      variantId = inputEl.value;
    }
  }

  if (!variantId) {
    console.error('No variant ID provided to addProductToCart');
    alert('Please select a size or option before adding to bag.');
    return;
  }

  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', quantity);

  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
    .then(async res => {
      const data = await res.json();
      if (!res.ok) {
        const errorMsg = data.description || data.message || 'Unable to add item to bag.';
        throw new Error(errorMsg);
      }
      return data;
    })
    .then(() => {
      refreshCartDrawer();
      toggleCartDrawer(true);
    })
    .catch(err => {
      console.error('Error adding to cart:', err);
      const msg = (err.message || '').toLowerCase();
      if (msg.includes('inventory') || msg.includes('sold out') || msg.includes('out of stock')) {
        alert('【Shopify管理画面の設定が必要です】\n\nShopify側でこの商品の在庫数が「0かつ販売停止」と判定されているため、カート追加がブロックされました。\n\nCJ Dropshippingによる受注連携を行うには、以下の設定を行ってください：\n\n1. Shopify管理画面 ＞「商品管理」を開く\n2. この商品をクリック\n3. バリエーション設定で「在庫切れ時も販売を続ける (Continue selling when out of stock)」にチェックを入れて保存\n\n※これでCJに在庫がある商品をすぐに購入できるようになります。');
      } else {
        alert(err.message || 'Unable to add item to bag. Please try again.');
      }
    });
}

const HOUNDINGTON_COUNTRIES = {
  US: { name: 'United States', currency: 'USD', symbol: '$', rate: 1.0 },
  JP: { name: '日本 (Japan)', currency: 'JPY', symbol: '¥', rate: 155.0 },
  GB: { name: 'United Kingdom', currency: 'GBP', symbol: '£', rate: 0.79 },
  DE: { name: 'Deutschland', currency: 'EUR', symbol: '€', rate: 0.92 },
  FR: { name: 'France', currency: 'EUR', symbol: '€', rate: 0.92 },
  IT: { name: 'Italia', currency: 'EUR', symbol: '€', rate: 0.92 },
  ES: { name: 'España', currency: 'EUR', symbol: '€', rate: 0.92 },
  NL: { name: 'Nederland', currency: 'EUR', symbol: '€', rate: 0.92 },
  KR: { name: '대한민국 (Korea)', currency: 'KRW', symbol: '₩', rate: 1380.0 },
  CN: { name: '中国 (China)', currency: 'CNY', symbol: '¥', rate: 7.23 },
  CA: { name: 'Canada', currency: 'CAD', symbol: 'CA$', rate: 1.36 },
  AU: { name: 'Australia', currency: 'AUD', symbol: 'A$', rate: 1.52 },
  CH: { name: 'Schweiz / Suisse', currency: 'CHF', symbol: 'CHF', rate: 0.91 },
  SG: { name: 'Singapore', currency: 'SGD', symbol: 'S$', rate: 1.35 },
  HK: { name: '香港 (Hong Kong)', currency: 'HKD', symbol: 'HK$', rate: 7.82 },
  TW: { name: '台灣 (Taiwan)', currency: 'TWD', symbol: 'NT$', rate: 32.5 },
  NZ: { name: 'New Zealand', currency: 'NZD', symbol: 'NZ$', rate: 1.66 },
  SE: { name: 'Sverige', currency: 'SEK', symbol: 'kr', rate: 10.8 },
  NO: { name: 'Norge', currency: 'NOK', symbol: 'kr', rate: 10.9 },
  DK: { name: 'Danmark', currency: 'DKK', symbol: 'kr', rate: 6.9 },
  PL: { name: 'Polska', currency: 'PLN', symbol: 'zł', rate: 3.95 },
  MX: { name: 'México', currency: 'MXN', symbol: 'Mex$', rate: 17.5 },
  BR: { name: 'Brasil', currency: 'BRL', symbol: 'R$', rate: 5.2 },
  IN: { name: 'भारत (India)', currency: 'INR', symbol: '₹', rate: 83.5 },
  AE: { name: 'الإمارات (UAE)', currency: 'AED', symbol: 'AED', rate: 3.67 },
  SA: { name: 'السعودية (Saudi Arabia)', currency: 'SAR', symbol: 'SAR', rate: 3.75 },
  TH: { name: 'ประเทศไทย (Thailand)', currency: 'THB', symbol: '฿', rate: 36.8 },
  MY: { name: 'Malaysia', currency: 'MYR', symbol: 'RM', rate: 4.75 },
  PH: { name: 'Pilipinas', currency: 'PHP', symbol: '₱', rate: 57.5 },
  ID: { name: 'Indonesia', currency: 'IDR', symbol: 'Rp', rate: 16200.0 },
  VN: { name: 'Việt Nam', currency: 'VND', symbol: '₫', rate: 25400.0 },
  ZA: { name: 'South Africa', currency: 'ZAR', symbol: 'R', rate: 18.8 }
};

function formatMoney(cents) {
  if (cents === null || cents === undefined || isNaN(cents)) return '';
  const numCents = parseFloat(cents);

  const activeCountry = localStorage.getItem('mw_country') || window.HOUNDINGTON?.country || 'US';
  const cInfo = HOUNDINGTON_COUNTRIES[activeCountry] || HOUNDINGTON_COUNTRIES.US;
  const targetCurrency = cInfo.currency.toUpperCase();
  const shopifyCurrency = (window.HOUNDINGTON?.currency?.code || window.Shopify?.currency?.active || 'USD').toUpperCase();

  const zeroDecimalCurrencies = [
    'JPY', 'KRW', 'BIF', 'CLP', 'DJF', 'GNF', 'ISK', 'KMF', 'PYG', 'RWF', 'UGX', 'VND', 'VUV', 'XAF', 'XOF', 'XPF'
  ];
  const isZeroDecimal = zeroDecimalCurrencies.includes(targetCurrency);

  let amount = numCents / 100;
  // If Shopify server did not convert currency (e.g. store is in USD and market conversion not configured), convert dynamically:
  if (shopifyCurrency !== targetCurrency && cInfo.rate) {
    amount = amount * cInfo.rate;
  }

  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: targetCurrency,
      minimumFractionDigits: isZeroDecimal ? 0 : 2,
      maximumFractionDigits: isZeroDecimal ? 0 : 2
    }).format(amount);
  } catch (e) {
    const formatted = isZeroDecimal ? Math.round(amount).toLocaleString() : amount.toFixed(2);
    return `${cInfo.symbol}${formatted} ${targetCurrency}`;
  }
}

function escapeHtml(text) {
  if (!text) return '';
  return text.replace(/[&<>"']/g, function(m) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[m];
  });
}

// ==========================================================================
// 2. PRODUCT DETAIL PAGE (PDP) VARIANT & SIZING ENGINE (CJ DROPSHIPPING COMPATIBLE)
// ==========================================================================
let currentProductData = null;
let selectedOptions = {};

function initProductVariantSelector(productJson) {
  currentProductData = productJson;
  if (!currentProductData || !currentProductData.variants || currentProductData.variants.length === 0) return;

  // Determine initial variant: from form input if preset, or first available / first variant
  const selectedVariantId = document.getElementById('selectedVariantId')?.value;
  let initialVariant = currentProductData.variants.find(v => String(v.id) === String(selectedVariantId));
  if (!initialVariant) {
    initialVariant = currentProductData.variants.find(v => v.available) || currentProductData.variants[0];
  }

  // Populate selectedOptions from initialVariant
  if (initialVariant && currentProductData.options) {
    currentProductData.options.forEach((opt, idx) => {
      const optName = typeof opt === 'object' && opt !== null ? (opt.name || opt.title) : opt;
      const val = initialVariant.options ? initialVariant.options[idx] : initialVariant['option' + (idx + 1)];
      if (optName && val) {
        selectedOptions[optName] = val;
      }
    });
  }
}

function handleOptionSelect(optionName, optionValue, swatchElement) {
  selectedOptions[optionName] = optionValue;

  // Update active state in UI
  if (swatchElement) {
    const parentContainer = swatchElement.closest('.visual-swatch-grid, .size-selection-grid');
    if (parentContainer) {
      parentContainer.querySelectorAll('.visual-swatch-card, .size-button-tile').forEach(el => el.classList.remove('active'));
      swatchElement.classList.add('active');
    }
  }

  // Update label text if present
  const lbl = document.getElementById(`lblOption_${escapeHtml(optionName)}`);
  if (lbl) lbl.textContent = optionValue;

  if (!currentProductData || !currentProductData.variants) return;

  // Find matching variant
  const matchedVariant = currentProductData.variants.find(variant => {
    if (!currentProductData.options || currentProductData.options.length === 0) return true;
    return currentProductData.options.every((opt, idx) => {
      const optName = typeof opt === 'object' && opt !== null ? (opt.name || opt.title) : opt;
      const expectedVal = selectedOptions[optName];
      if (!expectedVal) return true;
      const actualVal = variant.options ? variant.options[idx] : variant['option' + (idx + 1)];
      return String(expectedVal).trim().toLowerCase() === String(actualVal).trim().toLowerCase();
    });
  });

  if (matchedVariant) {
    // Update hidden form input
    const variantInput = document.getElementById('selectedVariantId');
    if (variantInput) variantInput.value = matchedVariant.id;

    // Update Price
    const priceSale = document.getElementById('mwPriceSale');
    const priceReg = document.getElementById('mwPriceRegular');
    const mobilePrice = document.getElementById('mobilePrice');
    if (priceSale) priceSale.textContent = formatMoney(matchedVariant.price);
    if (mobilePrice) mobilePrice.textContent = formatMoney(matchedVariant.price);
    if (priceReg) {
      if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
        priceReg.textContent = formatMoney(matchedVariant.compare_at_price);
        priceReg.style.display = 'inline';
      } else {
        priceReg.style.display = 'none';
      }
    }

    // Update Hero Image if variant has featured image
    if (matchedVariant.featured_image && matchedVariant.featured_image.src) {
      const heroImg = document.getElementById('pdpHeroImg');
      if (heroImg) {
        heroImg.style.opacity = '0.3';
        setTimeout(() => {
          heroImg.src = matchedVariant.featured_image.src;
          heroImg.style.opacity = '1';
        }, 120);
      }
    }

    // Determine availability (CJ Dropshipping aware)
    const isCjMode = window.HOUNDINGTON_CJ_DROPSHIPPING_MODE !== false;
    const isAvailable = matchedVariant.available || isCjMode;

    // Update Add to Cart Button state
    const addBtn = document.getElementById('addToBagBtn');
    if (addBtn) {
      addBtn.disabled = !isAvailable;
      const btnSpan = addBtn.querySelector('span');
      if (btnSpan) {
        btnSpan.textContent = isAvailable ? 'ADD TO SHOPPING BAG' : 'SOLD OUT';
      }
    }

    // Update Mobile Tray Button
    const mobileBtn = document.getElementById('mobileTrayBtn');
    if (mobileBtn) {
      mobileBtn.disabled = !isAvailable;
      const mobSpan = mobileBtn.querySelector('span');
      if (mobSpan) {
        mobSpan.textContent = isAvailable ? '+ ADD TO BAG' : 'SOLD OUT';
      }
    }
  }
}

// ==========================================================================
// 3. UI ACCORDIONS & NAVIGATION
// ==========================================================================
function toggleMegaDropdown() {
  const mega = document.getElementById('megaMenuPanel');
  if (mega) mega.classList.toggle('force-open');
}

function togglePdpAccordion(btn) {
  const item = btn.closest('.accordion-item');
  if (!item) return;
  item.classList.toggle('open');
  const icon = item.querySelector('.accordion-icon');
  if (icon) {
    icon.textContent = item.classList.contains('open') ? '−' : '+';
  }
}

// ==========================================================================
// 4. UNIVERSAL AUTO-TRANSLATION & LOCALIZATION (Japanese, Chinese, Korean, etc.)
// ==========================================================================

const HOUNDINGTON_I18N = {
  ja: {
    addToBag: "ショッピングバッグに追加",
    soldOut: "完売",
    shippingNotice: "すべてのご注文で追跡可能な配送をご利用いただけます*",
    trackingUpdates: "発送時にリアルタイムの追跡番号と配送状況をお知らせします",
    saleActive: "期間限定のシーズンセール価格が適用されています",
    shippingDisclaimer: "*一部の離島・遠隔地ではオンライン追跡がご利用いただけない場合があります。",
    shippingAccordion: "追跡可能配送と配送日数について",
    shippingAccordionBody: "小包が発送され次第、リアルタイムの追跡番号と配送状況の最新情報がメールで届きます。通常の配送期間は3〜6営業日です。<br><br><small style=\"color:#888;\">*注記：一部の離島・遠隔地ではオンライン追跡がご利用いただけない場合があります。</small>",
    myBag: "ショッピングバッグ",
    emptyBag: "ショッピングバッグは現在空です",
    emptyBagDesc: "愛犬のためのコレクションからお好みのアイテムをお選びください。",
    checkout: "ご購入手続きへ進む",
    subtotal: "小計（概算）:",
    orderTrackingDispatch: "発送時にオンライン追跡番号をご案内します*",
    mobileAddBag: "+ バッグに追加"
  },
  zh: {
    addToBag: "加入购物袋",
    soldOut: "已售罄",
    shippingNotice: "所有订单均提供全程物流追踪服务*",
    trackingUpdates: "发货后将即时通过邮件提供实时物流追踪单号",
    saleActive: "限时季节特惠折扣生效中",
    shippingDisclaimer: "*部分偏远或海岛地区的在线物流追踪可能受限。",
    shippingAccordion: "全程物流追踪与配送时效",
    shippingAccordionBody: "包裹发出后，您将收到包含实时追踪单号的通知邮件。常规配送时效为3至6个工作日。<br><br><small style=\"color:#888;\">*注：部分偏远或海岛地区的在线物流追踪可能受限。</small>",
    myBag: "购物袋",
    emptyBag: "购物袋当前为空",
    emptyBagDesc: "探索高级定制系列，为您的爱犬挑选精美服饰与配件。",
    checkout: "前往结账",
    subtotal: "预估小计:",
    orderTrackingDispatch: "发货后提供全程在线物流追踪*",
    mobileAddBag: "+ 加入购物袋"
  },
  ko: {
    addToBag: "쇼핑백에 담기",
    soldOut: "품절",
    shippingNotice: "모든 주문에 실시간 배송 조회가 제공됩니다*",
    trackingUpdates: "발송 즉시 실시간 배송 추적 번호와 업데이트가 이메일로 전송됩니다",
    saleActive: "시즌 한정 특별 세일 가격 적용 중",
    shippingDisclaimer: "*일부 도서산간 및 원격 지역의 경우 온라인 배송 조회가 제한될 수 있습니다.",
    shippingAccordion: "배송 추적 및 소요 기간",
    shippingAccordionBody: "소포가 발송되는 즉시 실시간 배송 조회 번호와 배송 상태 알림이 이메일로 전달됩니다. 일반 배송 소요 기간은 영업일 기준 3~6일입니다.<br><br><small style=\"color:#888;\">*안내: 일부 도서산간 및 원격 지역의 경우 배송 조회가 제한될 수 있습니다.</small>",
    myBag: "쇼핑백",
    emptyBag: "쇼핑백이 비어 있습니다",
    emptyBagDesc: "반려견을 위한 오트 쿠튀르 컬렉션에서 특별한 에ディション을 선택해보세요.",
    checkout: "주문 결제하기",
    subtotal: "예상 소계:",
    orderTrackingDispatch: "발송 즉시 온라인 배송 추적 정보 제공*",
    mobileAddBag: "+ 쇼핑백에 담기"
  },
  fr: {
    addToBag: "AJOUTER AU SAC",
    soldOut: "ÉPUISÉ",
    shippingNotice: "Livraison avec suivi incluse pour toutes les commandes*",
    trackingUpdates: "Numéro de suivi et notifications envoyés par e-mail dès l'expédition",
    saleActive: "Offre spéciale saisonnière appliquée",
    shippingDisclaimer: "*Le suivi en ligne peut être limité dans certaines zones isolées.",
    shippingAccordion: "Suivi de livraison et délais",
    shippingAccordionBody: "Dès l'expédition de votre colis, vous recevrez un e-mail avec un numéro de suivi en direct. Délai habituel : 3 à 6 jours ouvrés.<br><br><small style=\"color:#888;\">*Note : Le suivi peut être restreint dans certaines îles et zones reculées.</small>",
    myBag: "MON SAC DE SHOPPING",
    emptyBag: "VOTRE SAC EST ACTUELLEMENT VIDE",
    emptyBagDesc: "Découvrez notre collection Haute Couture pour chien et gâtez votre fidèle compagnon.",
    checkout: "PASSER LA COMMANDE",
    subtotal: "SOUS-TOTAL ESTIMÉ :",
    orderTrackingDispatch: "Suivi en ligne fourni dès l'expédition*",
    mobileAddBag: "+ AJOUTER AU SAC"
  },
  de: {
    addToBag: "IN DEN WARENKORB",
    soldOut: "AUSVERKAUFT",
    shippingNotice: "Sendungsverfolgung bei jeder Bestellung inklusive*",
    trackingUpdates: "Sendungsnummer & Status-Updates per E-Mail nach dem Versand",
    saleActive: "Saisonaler Sonderpreis aktiv",
    shippingDisclaimer: "*Online-Verfolgung in entlegenen Regionen teils eingeschränkt.",
    shippingAccordion: "Sendungsverfolgung & Lieferzeit",
    shippingAccordionBody: "Sobald Ihr Paket versandt wurde, erhalten Sie eine E-Mail mit Sendungsverfolgungsnummer. Lieferzeit: ca. 3–6 Werktage.<br><br><small style=\"color:#888;\">*Hinweis: In Insel- oder Randgebieten kann das Tracking eingeschränkt sein.</small>",
    myBag: "MEIN EINKAUFSKORB",
    emptyBag: "IHR EINKAUFSWAGEN IST MOMENTAN LEER",
    emptyBagDesc: "Entdecken Sie die Haute-Couture-Kollektion für Ihren Hund.",
    checkout: "ZUR KASSE GEHEN",
    subtotal: "GESAMTSUMME (GESCHÄTZT):",
    orderTrackingDispatch: "Online-Sendungsverfolgung ab Versand*",
    mobileAddBag: "+ IN DEN WARENKORB"
  },
  es: {
    addToBag: "AÑADIR A LA BOLSA",
    soldOut: "AGOTADO",
    shippingNotice: "Envío con seguimiento incluido en todos los pedidos*",
    trackingUpdates: "Número de seguimiento y avisos en tiempo real por correo electrónico",
    saleActive: "Promoción especial de temporada aplicada",
    shippingDisclaimer: "*El seguimiento en línea puede no estar disponible en zonas remotas o islas.",
    shippingAccordion: "Envío con seguimiento y tiempos de entrega",
    shippingAccordionBody: "Tan pronto como se envíe su paquete, recibirá un correo electrónico con el número de seguimiento en tiempo real. Plazo habitual de entrega: de 3 a 6 días laborables.<br><br><small style=\"color:#888;\">*Nota: El seguimiento en línea puede verse limitado en ciertas zonas remotas o islas.</small>",
    myBag: "MI BOLSA",
    emptyBag: "SU BOLSA DE COMPRA ESTÁ ACTUALMENTE VACÍA",
    emptyBagDesc: "Explore nuestra colección de Alta Costura canina y descubra piezas hechas a mano para su fiel compañero.",
    checkout: "TRAMITAR PEDIDO",
    subtotal: "SUBTOTAL ESTIMADO:",
    orderTrackingDispatch: "Seguimiento en línea proporcionado con el envío*",
    mobileAddBag: "+ AÑADIR A LA BOLSA"
  },
  pt: {
    addToBag: "ADICIONAR AO SACO",
    soldOut: "ESGOTADO",
    shippingNotice: "Envio com rastreamento incluído em todos os pedidos*",
    trackingUpdates: "Código de rastreamento em tempo real enviado por e-mail no envio",
    saleActive: "Promoção especial de temporada aplicada",
    shippingDisclaimer: "*O rastreamento online pode não estar disponível em algumas ilhas ou áreas remotas.",
    shippingAccordion: "Envio com rastreamento e prazos de entrega",
    shippingAccordionBody: "Assim que a sua encomenda for enviada, receberá um e-mail com o número de rastreamento em tempo real. O prazo habitual de entrega é de 3 a 6 dias úteis.<br><br><small style=\"color:#888;\">*Nota: O rastreamento online pode estar sujeito a limitações em regiões remotas ou ilhas.</small>",
    myBag: "O MEU SACO",
    emptyBag: "O SEU SACO DE COMPRAS ESTÁ VAZIO",
    emptyBagDesc: "Descubra a nossa coleção de Alta-Costura canina e encontre criações artesanais para o seu companheiro.",
    checkout: "FINALIZAR COMPRA",
    subtotal: "SUBTOTAL ESTIMADO:",
    orderTrackingDispatch: "Rastreamento online fornecido com o envio*",
    mobileAddBag: "+ ADICIONAR AO SACO"
  }
};

function applyInstantUiTranslations(lang) {
  const dict = HOUNDINGTON_I18N[lang];
  if (!dict) return;

  // Add to bag button
  const ctaBtn = document.querySelector('.cta-main-add-btn span');
  if (ctaBtn) {
    if (ctaBtn.textContent.includes('BAG') || ctaBtn.textContent.includes('バッグ') || ctaBtn.textContent.includes('购物袋') || ctaBtn.textContent.includes('쇼핑백')) {
      ctaBtn.textContent = dict.addToBag;
    } else if (ctaBtn.textContent.includes('SOLD') || ctaBtn.textContent.includes('完売') || ctaBtn.textContent.includes('售罄') || ctaBtn.textContent.includes('품절')) {
      ctaBtn.textContent = dict.soldOut;
    }
  }

  // Mobile tray button
  const mobileBtn = document.querySelector('#mobileTrayBtn span');
  if (mobileBtn) {
    if (mobileBtn.textContent.includes('BAG') || mobileBtn.textContent.includes('バッグ') || mobileBtn.textContent.includes('袋')) {
      mobileBtn.textContent = dict.mobileAddBag;
    } else if (mobileBtn.textContent.includes('SOLD') || mobileBtn.textContent.includes('完売') || mobileBtn.textContent.includes('售罄')) {
      mobileBtn.textContent = dict.soldOut;
    }
  }

  // Perks
  const perks = document.querySelectorAll('.atelier-perk-row span');
  if (perks.length >= 3) {
    perks[0].textContent = dict.shippingNotice;
    perks[1].textContent = dict.trackingUpdates;
    perks[2].textContent = dict.saleActive;
  }

  // Disclaimer
  const disclaimer = document.querySelector('.pdp-sticky-buybox p[style*="font-size:10px"]');
  if (disclaimer) disclaimer.textContent = dict.shippingDisclaimer;

  // Accordion trigger and body
  const accTrigger = document.querySelector('.accordion-trigger-title');
  if (accTrigger) accTrigger.textContent = dict.shippingAccordion;
  const accBody = document.querySelector('.accordion-body');
  if (accBody) accBody.innerHTML = dict.shippingAccordionBody;

  // Cart drawer checkout button
  const chkBtn = document.querySelector('.drawer-btn-checkout');
  if (chkBtn) chkBtn.textContent = dict.checkout;

  const subtotalLabel = document.querySelector('.drawer-subtotal-flex span:first-child');
  if (subtotalLabel) subtotalLabel.textContent = dict.subtotal;

  const drawerNotice = document.querySelector('#drawerShippingNotice');
  if (drawerNotice) drawerNotice.textContent = dict.orderTrackingDispatch;
}

function handleShopifyLanguageChange(selectElement) {
  if (!selectElement) return;
  let selectedValue = selectElement.value;
  if (selectedValue === 'zh') selectedValue = 'zh-CN';

  // 1. Sync all language dropdowns on page
  document.querySelectorAll('select[name="locale_code"], #mwLangSelect').forEach(sel => {
    sel.value = selectElement.value;
  });

  // 2. Persist selection
  localStorage.setItem('mw_lang', selectedValue);

  // 3. Apply instant UI dictionary translations
  const baseLang = selectedValue.split('-')[0];
  applyInstantUiTranslations(baseLang);

  // 4. Configure Google Translate cookies
  const host = window.location.hostname;
  const domainParts = host.split('.');
  let rootDomain = null;
  if (domainParts.length > 2) {
    rootDomain = domainParts.slice(-2).join('.');
  }

  if (selectedValue === 'en') {
    document.cookie = "googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = `googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.${host}; path=/;`;
    if (rootDomain) {
      document.cookie = `googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.${rootDomain}; path=/;`;
    }
  } else {
    const cookieVal = `/en/${selectedValue}`;
    document.cookie = `googtrans=${cookieVal}; path=/;`;
    document.cookie = `googtrans=${cookieVal}; domain=.${host}; path=/;`;
    if (rootDomain) {
      document.cookie = `googtrans=${cookieVal}; domain=.${rootDomain}; path=/;`;
    }
  }

  // 5. Trigger Google Translate
  const teCombo = document.querySelector('.goog-te-combo');
  if (teCombo) {
    teCombo.value = selectedValue;
    teCombo.dispatchEvent(new Event('change'));
  } else {
    // If not ready yet or changing cookie, reload smoothly so Google translates the entire page on load
    window.location.reload();
  }

  // 6. Coordinate with Shopify native route if published
  const selectedOption = selectElement.options[selectElement.selectedIndex];
  const isNative = selectedOption && selectedOption.getAttribute('data-native') === 'true';
  const targetUrl = selectedOption ? selectedOption.getAttribute('data-url') : null;

  if (isNative && targetUrl && targetUrl !== '#' && !targetUrl.includes('undefined')) {
    window.location.href = targetUrl;
  }
}

function refreshPagePrices() {
  const activeCountry = localStorage.getItem('mw_country') || window.HOUNDINGTON?.country || 'US';
  const cInfo = HOUNDINGTON_COUNTRIES[activeCountry] || HOUNDINGTON_COUNTRIES.US;

  // 1. Update PDP buybox prices
  const priceSale = document.getElementById('mwPriceSale');
  const mobilePrice = document.getElementById('mobilePrice');
  const priceReg = document.getElementById('mwPriceRegular');

  if (priceSale && priceSale.dataset.cents) {
    priceSale.textContent = formatMoney(priceSale.dataset.cents);
  }
  if (mobilePrice && priceSale && priceSale.dataset.cents) {
    mobilePrice.textContent = formatMoney(priceSale.dataset.cents);
  }
  if (priceReg && priceReg.dataset.cents) {
    const regCents = parseFloat(priceReg.dataset.cents);
    const saleCents = parseFloat(priceSale?.dataset?.cents || 0);
    if (regCents > saleCents) {
      priceReg.textContent = formatMoney(regCents);
      priceReg.style.display = 'inline-block';
    } else {
      priceReg.style.display = 'none';
    }
  }

  // 2. Update collection cards
  document.querySelectorAll('.product-luxury-card').forEach(card => {
    const pCurrent = card.querySelector('.price-amount-current');
    const pReg = card.querySelector('.price-amount-regular');
    if (pCurrent && pCurrent.dataset.cents) {
      pCurrent.textContent = formatMoney(pCurrent.dataset.cents);
    }
    if (pReg && pReg.dataset.cents) {
      pReg.textContent = formatMoney(pReg.dataset.cents);
    }
  });

  // 3. Update Cart Drawer
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      renderCartDrawer(cart);
    })
    .catch(() => {});
}

function handleShopifyCountryChange(selectElement) {
  if (!selectElement) return;
  const countryCode = selectElement.value;
  const cInfo = HOUNDINGTON_COUNTRIES[countryCode] || HOUNDINGTON_COUNTRIES.US;

  // 1. Sync all country select elements on page
  document.querySelectorAll('select[name="country_code"], #mwCountrySelect').forEach(sel => {
    sel.value = countryCode;
  });

  // 2. Persist in localStorage
  localStorage.setItem('mw_country', countryCode);
  localStorage.setItem('mw_currency', cInfo.currency);

  // 3. Update active currency in runtime memory
  if (window.HOUNDINGTON) {
    window.HOUNDINGTON.country = countryCode;
    window.HOUNDINGTON.currency = {
      code: cInfo.currency,
      symbol: cInfo.symbol,
      name: cInfo.name
    };
  }

  // 4. Immediately convert and update all prices on current page
  refreshPagePrices();

  // 5. Submit form if native Shopify market is configured for this country
  const selectedOption = selectElement.options[selectElement.selectedIndex];
  const isNative = selectedOption && selectedOption.getAttribute('data-native') === 'true';
  const form = selectElement.closest('form');
  if (isNative && form) {
    form.submit();
  }
}

function submitLocalizationForm(formId) {
  const form = document.getElementById(formId);
  if (form) form.submit();
}

// ==========================================================================
// 6. SPECIAL CAMPAIGN & COUPON SYSTEM (CCETKFR0KEF1 - Valid until Oct 10 00:00 JST)
// ==========================================================================
const COUPON_CODE = 'CCETKFR0KEF1';
// October 10th 2026, 00:00:00 JST = October 9th 2026 15:00:00 UTC (1760022000000 ms)
const COUPON_EXPIRY_JST = new Date('2026-10-10T00:00:00+09:00').getTime();

function isCouponCampaignActive() {
  return Date.now() < COUPON_EXPIRY_JST;
}

function copyCouponCode(code, btnElement) {
  const targetCode = code || COUPON_CODE;
  navigator.clipboard.writeText(targetCode).then(() => {
    if (btnElement) {
      const originalText = btnElement.innerHTML;
      btnElement.classList.add('copied');
      btnElement.innerHTML = 'COPIED! ✓';
      setTimeout(() => {
        btnElement.classList.remove('copied');
        btnElement.innerHTML = originalText;
      }, 2500);
    }
  }).catch(() => {
    prompt('Copy promo code:', targetCode);
  });
}

function openCouponModal() {
  const modal = document.getElementById('houndingtonCouponModal');
  if (modal) {
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }
}

function closeCouponModal() {
  const modal = document.getElementById('houndingtonCouponModal');
  if (modal) {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }
  localStorage.setItem('houndington_coupon_seen', 'true');
}

function handleCouponModalBackdropClick(event) {
  if (event.target && event.target.id === 'houndingtonCouponModal') {
    closeCouponModal();
  }
}

// Auto-initialize on page load
document.addEventListener('DOMContentLoaded', () => {
  // 1. Check coupon campaign period
  if (isCouponCampaignActive()) {
    // Show persistent floating coupon pill
    const floatingPill = document.getElementById('houndingtonFloatingCouponTrigger');
    if (floatingPill) {
      floatingPill.style.display = 'block';
    }

    // First-time visit auto popup (once per session/visit)
    const hasSeenModal = sessionStorage.getItem('houndington_coupon_popup_shown');
    if (!hasSeenModal) {
      setTimeout(() => {
        openCouponModal();
        sessionStorage.setItem('houndington_coupon_popup_shown', 'true');
      }, 800);
    }
  } else {
    // Hide promotion elements if campaign expired
    const sys = document.getElementById('houndingtonCouponSystem');
    if (sys) sys.style.display = 'none';
    const pdpCoupon = document.querySelector('.pdp-coupon-callout-card');
    if (pdpCoupon) pdpCoupon.style.display = 'none';
    const pdpPerk = document.getElementById('pdpCouponPerk');
    if (pdpPerk) pdpPerk.textContent = 'Special Seasonal Offers Available';
  }

  // Check cart count on initial load
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const counter = document.getElementById('mwCartCounter');
      if (counter) counter.textContent = cart.item_count;
    })
    .catch(() => {});

  // Sync country and update prices if saved
  const savedCountry = localStorage.getItem('mw_country');
  if (savedCountry && HOUNDINGTON_COUNTRIES[savedCountry]) {
    document.querySelectorAll('select[name="country_code"], #mwCountrySelect').forEach(sel => {
      sel.value = savedCountry;
    });
    refreshPagePrices();
  }

  // Sync language selects and apply instant dictionary
  const savedLang = localStorage.getItem('mw_lang') || 'en';
  document.querySelectorAll('select[name="locale_code"], #mwLangSelect').forEach(sel => {
    sel.value = savedLang;
  });
  if (savedLang !== 'en') {
    applyInstantUiTranslations(savedLang.split('-')[0]);
  }
});
